import { PatientsPaginationRequestDtoStatusEnum } from "libs/cellera-sdk/models/PatientsPaginationRequestDto";

export const getPatientDataSharingStatusLabel = (status?: string) => {
  switch (status) {
    case PatientsPaginationRequestDtoStatusEnum.ActiveSharing:
      return "Active Sharing";
    case PatientsPaginationRequestDtoStatusEnum.Revoked:
      return "Revoked";
    case PatientsPaginationRequestDtoStatusEnum.Requesting:
      return "Requesting";
    default:
      return "N/A";
  }
};
